import { Component, OnInit, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {BookingService,HomeService, DataService } from '../services/index'
import {Results } from '../models/index'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { Base64 } from 'js-base64';
import { EMPTY } from 'rxjs';
import { WhitelabelConfigStore } from '../core/config/whitelabel-config.store';
import {
  SEAT_CONFLICT_RECOVERY_STORAGE_KEY,
  SeatConflictRecovery
} from '../core/booking/seat-conflict-recovery';

interface ScheduleFarePrice {
  currency: 'KSH' | 'UGX';
  amount: number;
}

interface ScheduleSeatFare {
  seatType: string;
  prices: ScheduleFarePrice[];
}

@Component({
    selector: 'app-booking',
    templateUrl: './booking.component.html',
    styleUrl: './booking-seat-drawer.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingComponent implements OnInit {
  reactiveForm: UntypedFormGroup;reactiveMobileForm: UntypedFormGroup;pickupForm: UntypedFormGroup;

  public pickupplaceholder: string = 'Boarding Point';
  public dropoffplaceholder: string = 'Dropoff Point';
  public keyword = 'name';
  checkiftoday:boolean;
  public pickplaceholder: string = 'Enter Pick Up';
  public destplaceholder: string = 'Enter Drop Off';
  public historyHeading: string = 'Recently selected';
  today=new Date();
  bsValue = new Date();
  destinationLoading=false;
  beforeyesterday:Date =( d => new Date(d.setDate(d.getDate()-2)) )(new Date);
  yesterday:Date = ( d => new Date(d.setDate(d.getDate()-1)) )(new Date);
  tomorrow:Date = ( d => new Date(d.setDate(d.getDate()+1)) )(new Date);
  aftertomorrow:Date = ( d => new Date(d.setDate(d.getDate()+2)) )(new Date);

  //traveldate:any;
  data = [];cities_data = [];formdata={};
  formdataTravel={};
  formdataReturn={};
  private sub: any;
  res: any = {};
  schedule: any ={};
  routename: any ={};
  pickup:any =[];
  dropoff:any =[];
  seatsSelected: any=[];
  seats =[];
  seatData:any =[];
  selectedBus:any;
  selectedBusStatus:boolean=false;
  fleet: any ={};
  seat_price: any ={};
  params:any;
  bookingdetails: any;
  results: any = [];
  return_schedule:any;
  resultsholder: any=[];
  seatMobile:any =[];
  isResultsLoading=false;
  showSeats=false;
  changeI=false;
  pickUpInit: string;
  dropOffInit: string;
  travelDateInit: string;
  isUnavailabe=false;
  dataLoading=false;
  isReturnTicket=false;
  isShowingFilter=false;
  totalFare=0;
  returning=false;
  selectedIndex = -1;
  selectedDepatureId:string;
  selectedDestinationId:string;
  fromPlaceholder="From";
  searchDate:string;
  toPlaceholder="To";
  isreturnsearch:boolean;
  traveldate = formatDate(new Date(), 'yyyy-MM-dd', 'en-KE');
  returndate = '';
  allSeatArray=[];
  bookedSeatArray=[];
  booked_seat_session_id='';
  seatErrors=false;
  seatDataNew:any =[];
  seatRes:any;
  IsDiscount=false
  availableSeats=[];
  availableSeatCount: number | null = null;
  discountAmount:any;
  busSelected:any;
  isBusSelected:boolean =false;
  busOperatorSelected:any;
  currentBusId:any;
  submitted:boolean =false;
  submittedMashPoa:boolean =false;
  isReturnTicketSelected=false;
  finalReturnDateInit:string;
  finalTravelDate: string;


 // pickupanddropoff
  pickuplocation:string =""
  dropofflocation:string =""
  pickupreturnlocation:string =""
  dropoffreturnlocation:string =""

  totalFareKSH: number = 0;
  totalFareUGX: number = 0;
  editSearchOpen = false;
  filterDrawerOpen = false;
  seatDrawerOpen = false;
  boardingDrawerOpen = false;
  expressOnly = false;
  departurePeriod = 'all';
  standardOnly = false;
  businessOnly = false;
  vipOnly = false;
  wifiOnly = false;
  acOnly = false;
  chargingOnly = false;
  dateStripOffset = 0;
  seatRecoveryMessage = '';
  readonly driverColumn = 5;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service:BookingService,
    private homeservice:HomeService,
    private dataService:DataService,
    private _fb: UntypedFormBuilder,
    public readonly configStore: WhitelabelConfigStore
  ) {
    this.reactiveForm = _fb.group({
      pickup:['', Validators.required],
      dropoff:['', Validators.required],
      traveldate:[new Date(), Validators.required],
      returndate:[]
    });
    this.reactiveMobileForm = _fb.group({
      pickup:['', Validators.required],
      dropoff:['', Validators.required],
      traveldate:[new Date(), Validators.required],
      returndate:[]
    });

     // pickupanddropoff
     this.pickupForm = _fb.group({
      pickupLocation:['', Validators.required],
      dropoffLocation:['', Validators.required],
    });

   }

   returnClicked = () =>{
    this.returning=true;
  }

  closeReturn = () =>{
    this.returning=false;
  }

  showFilter () {
    this.isShowingFilter=true;

  }
  hideFilter() {
    this.isShowingFilter=false;

  }

       // pickupanddropoff
       get fpickup() { return this.pickupForm.controls; }

  ngOnInit() {

    this.loadDestinations();
    
    this.dataService.currentMessage.subscribe(message =>{

      if(!message){
          message=localStorage.getItem('search-mashpoa');
      if(!message){
        this.router.navigate(['/']);
        return;
      }
    }

     localStorage.setItem('search-mashpoa', message);
      this.bookingdetails = JSON.parse(Base64.decode(message))
      this.traveldate = formatDate(this.bookingdetails.traveldate, 'yyyy-MM-dd', 'en-KE');
      this.returning = Boolean(this.bookingdetails.returning);
      this.returndate = this.returning && this.bookingdetails.returndate
        ? formatDate(this.bookingdetails.returndate, 'yyyy-MM-dd', 'en-KE')
        : '';
      this.pickUpInit=this.bookingdetails.pickupname;
      this.dropOffInit=this.bookingdetails.dropoffname;
      this.travelDateInit=this.bookingdetails.traveldate;
      this.fromPlaceholder = this.bookingdetails.pickupname;
      this.toPlaceholder = this.bookingdetails.dropoffname;
      this.isreturnsearch=this.bookingdetails.returning;
      this.searchDate = formatDate(this.travelDateInit,"yyyy-MM-dd","en-KE");
      this.checkDates();
      this.reopenSeatDrawerFromCheckout();
      this.searchBuses(JSON.parse(Base64.decode(message)))
    });

  }

  get config() {
    return this.configStore.snapshot.config;
  }

  get filteredResults(): any[] {
    return (this.results || []).filter(result => {
      const availableSeats = result?.number_of_available_seats;
      const availableSeatCount = Number(availableSeats);
      if (availableSeats !== undefined && availableSeats !== null &&
          Number.isFinite(availableSeatCount) && availableSeatCount <= 0) {
        return false;
      }
      if (this.expressOnly && !result.is_express_travel) {
        return false;
      }
      if (this.standardOnly && !this.hasSeatType(result, 'standard')) {
        return false;
      }
      if (this.businessOnly && !this.hasSeatType(result, 'business')) {
        return false;
      }
      if (this.vipOnly && !this.hasSeatType(result, 'vip')) {
        return false;
      }
      if (this.wifiOnly && !this.hasAmenity(result, 'wi-fi')) {
        return false;
      }
      if (this.acOnly && !this.hasAmenity(result, 'ac')) {
        return false;
      }
      if (this.chargingOnly && !this.hasAmenity(result, 'charging')) {
        return false;
      }
      if (this.departurePeriod === 'all') {
        return true;
      }
      const rawTime = String(result.departure_time || '');
      const match = rawTime.match(/(\d{1,2}):(\d{2})/);
      if (!match) {
        return true;
      }
      const hour = Number(match[1]);
      return this.departurePeriod === 'morning'
        ? hour < 12
        : this.departurePeriod === 'afternoon'
          ? hour >= 12 && hour < 18
          : hour >= 18;
    });
  }

  get dateOptions(): Date[] {
    return [this.yesterday, new Date(this.travelDateInit), this.tomorrow];
  }

  get resultDateOptions(): Date[] {
    const baseKey = formatDate(this.travelDateInit || this.today, 'yyyy-MM-dd', 'en-KE');
    const base = new Date(`${baseKey}T00:00:00`);
    base.setDate(base.getDate() + this.dateStripOffset);
    return Array.from({ length: 4 }, (_, index) => {
      const date = new Date(base);
      date.setDate(base.getDate() + index);
      return date;
    });
  }

  get selectedSeatLabels(): string {
    return this.seatsSelected.map(seat => seat.id).join(', ');
  }

  seatFares(result: any): ScheduleSeatFare[] {
    const seatsTypes: any[] = Array.isArray(result?.seats_types) ? result.seats_types : [];
    const currencies = result?.currencies || {};
    const fares = new Map<string, ScheduleSeatFare>();
    const consumedCurrencyGroups = new Set<string>();

    const addFare = (seatType: string, rawPrices: any, fallbackKsh = 0) => {
      const label = String(seatType || 'Seat');
      const key = label.trim().toLowerCase();
      if (fares.has(key)) {
        return;
      }
      const ksh = this.currencyFare(rawPrices, ['KSH', 'Ksh', 'ksh', 'KES', 'Kes', 'kes']) || fallbackKsh;
      const ugx = this.currencyFare(rawPrices, ['UGX', 'Ugx', 'ugx']);
      const prices: ScheduleFarePrice[] = [
        ...(ksh > 0 ? [{ currency: 'KSH' as const, amount: ksh }] : []),
        ...(ugx > 0 ? [{ currency: 'UGX' as const, amount: ugx }] : [])
      ];
      if (prices.length) {
        fares.set(key, { seatType: label, prices });
      }
    };

    seatsTypes.forEach((type: any) => {
      if (!type) {
        return;
      }
      const label = type.name || type.alias || 'Seat';
      const aliases = [type.alias, type.name]
        .filter(Boolean)
        .map(value => String(value).toLowerCase());
      const groupKey = Object.keys(currencies).find(key => aliases.includes(key.toLowerCase()));
      if (groupKey) {
        consumedCurrencyGroups.add(groupKey);
      }
      addFare(label, groupKey ? currencies[groupKey] : {}, Number(type.fare) || 0);
    });

    Object.keys(currencies)
      .filter(seatType => !consumedCurrencyGroups.has(seatType))
      .forEach(seatType => addFare(seatType, currencies[seatType]));

    if (fares.size) {
      return Array.from(fares.values()).sort((left, right) =>
        Math.min(...left.prices.map(price => price.amount)) -
        Math.min(...right.prices.map(price => price.amount))
      );
    }

    const fallback = Number(result?.fare);
    return fallback > 0
      ? [{ seatType: 'Seat', prices: [{ currency: 'KSH', amount: fallback }] }]
      : [];
  }

  private currencyFare(prices: any, keys: string[]): number {
    for (const key of keys) {
      const amount = Number(prices?.[key]);
      if (amount > 0) {
        return amount;
      }
    }
    return 0;
  }

  shiftDateStrip(direction: -1 | 1): void {
    this.dateStripOffset = Math.max(0, this.dateStripOffset + (direction * 4));
  }

  dateStripTag(date: Date): string {
    const dateKey = formatDate(date, 'yyyy-MM-dd', 'en-KE');
    const todayKey = formatDate(this.today, 'yyyy-MM-dd', 'en-KE');
    const tomorrow = new Date(this.today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowKey = formatDate(tomorrow, 'yyyy-MM-dd', 'en-KE');
    return dateKey === todayKey ? 'Today' : dateKey === tomorrowKey ? 'Tomorrow' : formatDate(date, 'EEE', 'en-KE');
  }

  isSelectedResultDate(date: Date): boolean {
    if (!this.travelDateInit) {
      return false;
    }
    return formatDate(date, 'yyyy-MM-dd', 'en-KE') === formatDate(this.travelDateInit, 'yyyy-MM-dd', 'en-KE');
  }

  fareCurrencyLabel(currency: string): string {
    return ['KSH', 'KES'].includes(String(currency).toUpperCase()) ? 'Ksh' : currency;
  }

  formatResultTime(value: unknown): string {
    const match = String(value || '').match(/(\d{1,2}):(\d{2})/);
    if (!match) {
      return String(value || '—');
    }
    const hours = Number(match[1]);
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${match[2]} ${period}`;
  }

  isOvernightArrival(result: any): boolean {
    const departure = this.timeInMinutes(result?.departure_time);
    const arrival = this.timeInMinutes(result?.arrival_time);
    if (departure === null || arrival === null) {
      return false;
    }
    return arrival < departure;
  }

  resultDepartureDate(result: any): string {
    const value = result?.departure_date || result?.travel_date || this.travelDateInit;
    return this.formatResultDate(value);
  }

  resultArrivalDate(result: any): string {
    const explicitDate = result?.arrival_date;
    if (explicitDate) {
      return this.formatResultDate(explicitDate);
    }

    const departureValue = result?.departure_date || result?.travel_date || this.travelDateInit;
    return this.formatResultDate(departureValue, this.isOvernightArrival(result) ? 1 : 0);
  }

  private formatResultDate(value: unknown, daysToAdd = 0): string {
    if (!value) {
      return '—';
    }

    const dateKey = String(value).match(/\d{4}-\d{2}-\d{2}/)?.[0];
    const date = dateKey ? new Date(`${dateKey}T00:00:00`) : new Date(value as any);
    if (Number.isNaN(date.getTime())) {
      return '—';
    }
    date.setDate(date.getDate() + daysToAdd);
    return formatDate(date, 'EEE, d MMM', 'en-KE');
  }

  tripDuration(result: any): string {
    const supplied = result?.duration || result?.travel_duration || result?.estimated_duration;
    if (typeof supplied === 'string' && supplied.trim()) {
      return supplied;
    }
    if (typeof supplied === 'number' && supplied > 0) {
      return this.formatDurationMinutes(supplied);
    }

    const departure = this.timeInMinutes(result?.departure_time);
    const arrival = this.timeInMinutes(result?.arrival_time);
    if (departure === null || arrival === null) {
      return '';
    }
    const minutes = arrival >= departure ? arrival - departure : (24 * 60) - departure + arrival;
    return this.formatDurationMinutes(minutes);
  }

  routeLabel(result: any): string {
    const route = result?.route;
    if (typeof route === 'string' && route.trim()) {
      return route.trim();
    }

    const explicitName = route?.name || route?.title || route?.label ||
      result?.route_name || result?.routeName ||
      result?.schedule?.route?.name || result?.schedule?.route_name;
    if (explicitName) {
      return String(explicitName);
    }

    const origin = route?.origin || route?.from || result?.origin ||
      result?.origin_city_name || result?.from || this.pickUpInit;
    const destination = route?.destination || route?.to || result?.destination ||
      result?.destination_city_name || result?.to || this.dropOffInit;
    return [this.pointLabel(origin), this.pointLabel(destination)].filter(Boolean).join(' → ');
  }

  clearResultFilters(): void {
    this.standardOnly = false;
    this.businessOnly = false;
    this.vipOnly = false;
    this.wifiOnly = false;
    this.acOnly = false;
    this.chargingOnly = false;
    this.expressOnly = false;
    this.departurePeriod = 'all';
  }

  get hasActiveResultFilters(): boolean {
    return this.standardOnly || this.businessOnly || this.vipOnly || this.wifiOnly || this.acOnly ||
      this.chargingOnly || this.expressOnly || this.departurePeriod !== 'all';
  }

  private hasSeatType(result: any, requested: 'standard' | 'business' | 'vip'): boolean {
    const types = [
      ...Object.keys(result?.currencies || {}),
      ...(result?.seats_types || []).flatMap((type: any) => [type?.alias, type?.name])
    ].filter(Boolean).map(type => String(type).toLowerCase());

    if (requested === 'vip') {
      return types.some(type => type.includes('vip'));
    }
    if (requested === 'business') {
      return types.some(type => type.includes('business'));
    }
    return !types.length || types.some(type =>
      type.includes('standard') || type.includes('normal') || type.includes('economy')
    );
  }

  private hasAmenity(result: any, requested: string): boolean {
    const aliases: Record<string, string[]> = {
      'wi-fi': ['wi-fi', 'wifi', 'wi fi'],
      ac: ['ac', 'air conditioning', 'air-conditioning'],
      charging: ['charging', 'charger', 'power', 'usb']
    };
    const amenities = (result?.amenities || [])
      .map((amenity: any) => (this.pointLabel(amenity) || String(amenity)).toLowerCase());
    return (aliases[requested] || [requested]).some(alias =>
      amenities.some((amenity: string) => amenity.includes(alias))
    );
  }

  amenityKind(amenity: any): 'wifi' | 'ac' | 'charging' | 'other' {
    const label = (this.pointLabel(amenity) || String(amenity || '')).toLowerCase();
    if (label.includes('wifi') || label.includes('wi-fi') || label.includes('wi fi')) {
      return 'wifi';
    }
    if (label === 'ac' || label.includes('air condition')) {
      return 'ac';
    }
    if (label.includes('charg') || label.includes('power') || label.includes('usb')) {
      return 'charging';
    }
    return 'other';
  }

  amenityDisplayLabel(amenity: any): string {
    const kind = this.amenityKind(amenity);
    if (kind === 'wifi') {
      return 'Wi-Fi';
    }
    if (kind === 'ac') {
      return 'AC';
    }
    if (kind === 'charging') {
      return 'Charging';
    }
    return this.pointLabel(amenity) || String(amenity || '');
  }

  private timeInMinutes(value: unknown): number | null {
    const match = String(value || '').match(/(\d{1,2}):(\d{2})/);
    return match ? (Number(match[1]) * 60) + Number(match[2]) : null;
  }

  private formatDurationMinutes(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const remainder = minutes % 60;
    return `${hours}h${remainder ? ` ${remainder}m` : ''}`;
  }

  operatorName(result: any): string {
    return result?.operator?.name || result?.operator?.alias || this.config?.site.name || 'Bus operator';
  }

  pointLabel(point: any): string {
    return typeof point === 'string' ? point : point?.name || point?.title || point?.location || '';
  }

  pointSubtitle(point: any): string {
    if (typeof point === 'string') {
      return '';
    }
    return point?.address || point?.description || point?.landmark ||
      point?.subtitle || point?.details || point?.city || '';
  }

  pointTime(point: any, fallback: any): string {
    const value = typeof point === 'string' ? fallback :
      point?.time || point?.departure_time || point?.arrival_time ||
      point?.pickup_time || point?.dropoff_time || point?.estimated_time || fallback;
    return this.formatResultTime(value);
  }

  get boardingPointOptions(): any[] {
    return this.selectedBus?.boarding_points?.length
      ? this.selectedBus.boarding_points
      : [this.pickUpInit];
  }

  get dropoffPointOptions(): any[] {
    return this.selectedBus?.dropoff_points?.length
      ? this.selectedBus.dropoff_points
      : [this.dropOffInit];
  }

  selectJourneyPoint(controlName: 'pickupLocation' | 'dropoffLocation', point: any): void {
    this.pickupForm.get(controlName)?.setValue(this.pointLabel(point));
    this.pickupForm.get(controlName)?.markAsTouched();
  }

  isJourneyPointSelected(controlName: 'pickupLocation' | 'dropoffLocation', point: any): boolean {
    return this.pickupForm.get(controlName)?.value === this.pointLabel(point);
  }

  isSeatSpace(seat: any): boolean {
    if (String(seat?.type || '').toLowerCase() === 'skip') {
      return false;
    }
    return !['aisle', 'skip', 'blank', 'driver', 'door', 'conductor'].includes(
      String(seat?.space_type || '').toLowerCase()
    );
  }

  private seatFixtureKind(seat: any): 'aisle' | 'driver' | 'empty' {
    const kinds = [seat?.space_type, seat?.id, seat?.number, seat?.type]
      .map(value => String(value || '').trim().toLowerCase());
    if (kinds.includes('driver')) {
      return 'driver';
    }
    if (kinds.includes('aisle')) {
      return 'aisle';
    }
    if (kinds.includes('door')) {
      return 'empty';
    }
    return 'empty';
  }

  get seatLayoutRows(): Array<{ cells: any[] }> {
    return (this.seatMobile || [])
      .map((rawRow: any) => Array.isArray(rawRow) ? rawRow : [])
      .filter((row: any[]) => row.some(seat => this.isSeatSpace(seat)))
      .map((row: any[]) => {
        const spacesByColumn = new Map<number, any>();
        row.forEach((seat: any, index: number) => {
          const column = Number(seat?.column) || index + 1;
          spacesByColumn.set(column, seat);
        });

        return {
          cells: [1, 2, 3, 4, 5].map(column => {
            const space = spacesByColumn.get(column);
            if (space && this.isSeatSpace(space)) {
              return { kind: 'seat', seat: space };
            }
            const fixtureKind = this.seatFixtureKind(space);
            return {
              kind: fixtureKind === 'driver'
                ? 'empty'
                : fixtureKind === 'empty' && column === 3 ? 'aisle' : fixtureKind
            };
          })
        };
      });
  }

  isSeatAvailable(seat: any): boolean {
    return String(seat?.status || '').toLowerCase() === 'available';
  }

  isSeatTaken(seat: any): boolean {
    return !this.isSeatAvailable(seat);
  }

  isVipSeat(seat: any): boolean {
    const type = `${seat?.space_type || ''} ${seat?.type || ''}`.toLowerCase();
    return type.includes('vip');
  }

  isBusinessSeat(seat: any): boolean {
    const type = `${seat?.space_type || ''} ${seat?.type || ''}`.toLowerCase();
    return type.includes('business');
  }

  seatFareLabel(kind: 'standard' | 'business' | 'vip'): string {
    const matchingFare = this.seatFares(this.selectedBus).find(fare => {
      const name = fare.seatType.toLowerCase();
      return kind === 'vip'
        ? name.includes('vip')
        : kind === 'business'
          ? name.includes('business')
          : !name.includes('vip') && !name.includes('business');
    });
    const label = kind === 'vip' ? 'VIP' : kind === 'business' ? 'Business' : 'Normal';
    const prices = matchingFare?.prices.map(price =>
      `${this.fareCurrencyLabel(price.currency)} ${price.amount.toLocaleString('en-KE')}`
    ).join(' · ');
    return prices ? `${label} ${prices}` : label;
  }

  isSeatSelected(id: any): boolean {
    return this.seatsSelected.some(seat => String(seat.id) === String(id));
  }

  toggleSeat(result: any, seat: any): void {
    if (!this.isSeatAvailable(seat) || !this.isSeatSpace(seat)) {
      return;
    }
    const existing = this.seatsSelected.findIndex(item => String(item.id) === String(seat.id));
    const fares = this.resolveSeatFares(result, seat);
    if (existing >= 0) {
      this.seatsSelected.splice(existing, 1);
      this.totalFareKSH = Math.max(0, this.totalFareKSH - fares.ksh);
      this.totalFareUGX = Math.max(0, this.totalFareUGX - fares.ugx);
      return;
    }
    this.seatsSelected.push({
      id: seat.id,
      space_type: seat.space_type,
      fareKSH: fares.ksh,
      fareUGX: fares.ugx
    });
    this.totalFareKSH += fares.ksh;
    this.totalFareUGX += fares.ugx;
  }

  private resolveSeatFares(result: any, seat: any): { ksh: number; ugx: number } {
    const seatType = (result?.seats_types || []).find(
      item => String(item.alias).toLowerCase() === String(seat?.space_type).toLowerCase()
    );
    const currencies = seat?.fare?.currencies || {};
    const ksh = Number(currencies.KSH ?? currencies.Ksh ?? currencies.KES ?? seatType?.fare ?? 0) || 0;
    const ugx = Number(currencies.UGX ?? 0) || 0;
    return { ksh, ugx };
  }

  closeDrawers(): void {
    this.editSearchOpen = false;
    this.filterDrawerOpen = false;
    this.seatDrawerOpen = false;
    this.boardingDrawerOpen = false;
  }

  continueToBoarding(): void {
    if (!this.seatsSelected.length) {
      return;
    }
    this.seatDrawerOpen = false;
    this.boardingDrawerOpen = true;
  }

  backToSeats(): void {
    this.boardingDrawerOpen = false;
    this.seatDrawerOpen = true;
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeDrawers();
  }

  checkDates=() =>{
    let traveldate = formatDate(this.travelDateInit,"yyyy-MM-dd","en-KE");
    let today = formatDate(this.today,"yyyy-MM-dd","en-KE");
    var date = new Date(traveldate);
    this.beforeyesterday=new Date(date.setDate(date.getDate()-2));
    this.yesterday=new Date(date.setDate(date.getDate()+1));
    this.tomorrow =new Date(date.setDate(date.getDate()+2))
    this.aftertomorrow =new Date(date.setDate(date.getDate()+2));
      if(traveldate == today)
          return true;
      else
        return false;
  }
  changeDate=(selected) =>{

    this.travelDateInit=formatDate(selected,"yyyy-MM-dd","en-KE");
    this.checkDates();
    let webformdata={
      'pickup' :  this.pickUpInit,
      'dropoff' : this.dropOffInit,
      'pickupname' : this.pickUpInit,
      'dropoffname' :this.dropOffInit,
      'traveldate' :this.travelDateInit,
      'returndate': this.returning ? this.returndate : '',
      'returning' : this.returning
    }

    this.bookingdetails =webformdata
 
    let message=Base64.encode(JSON.stringify(webformdata));
    this.dataService.changeMessage(message);
    localStorage.setItem('search-mashpoa', message);

    this.searchBuses(webformdata);
  }

  interChange=()=>{
    this.changeI=!this.changeI;
    if(this.changeI){

      this.pickUpInit=this.bookingdetails.dropoffname;
      this.dropOffInit=this.bookingdetails.pickupname;
      this.travelDateInit=this.bookingdetails.traveldate;

       const dropOff = this.data.find(city => city.name === this.pickUpInit);
       const pickUp = this.data.find(city => city.name === this.dropOffInit);

      let webformdata={
        'pickup' : dropOff.id,
        'dropoff' : pickUp.id,
        'pickupname' : this.pickUpInit,
        'dropoffname' :this.dropOffInit,
        'traveldate' :this.travelDateInit,
        'returndate': this.returning ? this.returndate : '',
        'returning' : this.returning
      }
      this.bookingdetails =webformdata
      let message=Base64.encode(JSON.stringify(webformdata));
      this.dataService.changeMessage(message);
      localStorage.setItem('search-mashpoa', message);
      this.searchBuses(webformdata);
    }else{
      this.pickUpInit=this.bookingdetails.pickupname;
      this.dropOffInit=this.bookingdetails.dropoffname;
      this.travelDateInit=this.bookingdetails.traveldate;

       const dropOff = this.data.find(city => city.name === this.bookingdetails.dropoffname);
       const pickUp = this.data.find(city => city.name === this.bookingdetails.pickupname);

      let webformdata={
        'pickup' : pickUp.id,
        'dropoff' : dropOff.id,
        'pickupname' : this.pickUpInit,
        'dropoffname' :this.dropOffInit,
        'traveldate' :this.travelDateInit,
        'returndate': this.returning ? this.returndate : '',
        'returning' : this.returning
      }
      this.bookingdetails =webformdata

      let message=Base64.encode(JSON.stringify(webformdata));
      this.dataService.changeMessage(message);
      localStorage.setItem('search-mashpoa', message);

      this.searchBuses(webformdata);

    }
  }

  private loadDestinations= () => {
    let storedCities = localStorage.getItem('mashpoa-cities');
    
    if(storedCities){
      let list: string[] = [];
      this.cities_data = JSON.parse(Base64.decode(storedCities))

      this.cities_data.forEach(element => {
          list.push(element);
      });
    this.data=list;

    }else{
     this.router.navigate(['/'])
    }

  }

  interChangeValues(pickup,dropoff){
    this.fromPlaceholder = pickup;
    this.toPlaceholder = dropoff;
  }

  forMatThisData = (data) => {
    return formatDate(data,"dddd dS, M","en-KE");
  }

    // Get seat types from the 'currencies' object
    getSeatTypes(currencies) {
      return Object.keys(currencies).map(type => {
        return { type: type, prices: currencies[type] };
      });
    }
  
    // Get currency keys (like KSH, UGX)
    getCurrencyKeys(prices) {
      return Object.keys(prices);
    }

  submitWebForm(reactiveForm) {
    this.submitted = true;
    let value = reactiveForm;
    var traveldate = formatDate(value.traveldate,"yyyy-MM-dd","en-KE");
    value.traveldate=traveldate;
    const isRoundTrip = Boolean(this.bookingdetails?.returning || this.returning);
    const returndate = isRoundTrip && value.returndate
      ? formatDate(value.returndate, "yyyy-MM-dd", "en-KE")
      : '';

    let webformdata={
      'pickup' : value.pickup,
      'dropoff' : value.dropoff,
      'pickupname' : value.pickup,
      'dropoffname' :value.dropoff,
      'traveldate' : traveldate,
      'returndate': returndate,
      'returning' : isRoundTrip
    }
    this.bookingdetails =webformdata
    let message=Base64.encode(JSON.stringify(webformdata));
    localStorage.setItem('search-mashpoa', message);
    this.dataService.changeMessage(message);

    this.searchBuses(webformdata);
  }

  submitMobileForm() {
    this.submitted = true;
     let value = this.reactiveMobileForm.value;

    var traveldate = formatDate(value.traveldate,"yyyy-MM-dd","en-KE");
    value.traveldate=traveldate;


    let mobileformdata={
      'pickup' : value.pickup.id,
      'dropoff' : value.dropoff.id,
      'pickupname' : value.pickup.name,
      'dropoffname' : value.dropoff.name,
      'traveldate' : traveldate,
    }

    this.bookingdetails =mobileformdata
    let message=Base64.encode(JSON.stringify(mobileformdata));

    localStorage.setItem('search-mashpoa', message);

    this.searchBuses(mobileformdata);
  }

  toggleShow(results: any) {
    this.seatsSelected=[];
    this.totalFareUGX=0;
    this.totalFareKSH=0;
      results.hide_from_ui = ! results.hide_from_ui;
    }

    selectSeats(results: any) {

      this.selectedBus=results;
      this.seatDrawerOpen=true;
      this.boardingDrawerOpen=false;
      this.selectedBusStatus=true;
      this.dataLoading =true;
      this.seatsSelected=[];
      this.seatData = [];
      this.seatMobile=[];
      this.availableSeatCount=null;
      this.totalFareUGX=0;
      this.totalFareKSH=0;
      this.seats=[];
      let traveldate=formatDate(this.travelDateInit,"d-M-yyyy","en-KE");
      let query ={
        'fleet_registration_id': results.id,
        'date': traveldate,
        'start_point': results.origin_city_id,
        'end_point': results.destination_city_id,
        'alias': results.operator.alias,
        'rsc_id': results.route_schedule_id,
        'bus_id': results.id,
        'id': results.id,
        'no_of_seats': results.number_of_available_seats,
        'fare': results.fare,
        'leaving_from': results.from,
        'going_to': results.to,
      };
        this.getAvailableSeats(query);
      }


      getAvailableSeats(query){
        this.seatErrors=false;
        this.service.getSeats(query).subscribe(
        response => {
          this.seatErrors=false;
          this.seatRes = response;
          const availableSeatData = this.seatRes?.data?.available_seats || {};
          this.availableSeats = availableSeatData.available_seat_ids || [];
          this.seats = Array.isArray(availableSeatData.seats) ? availableSeatData.seats : [];
          this.booked_seat_session_id = availableSeatData.booked_seat_session_id || '';

          this.seatMobile = this.seats
            .map((row: any[]) => [...row].sort(
              (left: any, right: any) => Number(left?.column || 0) - Number(right?.column || 0)
            ))
            .sort((left: any[], right: any[]) =>
              Number(left[0]?.row || 0) - Number(right[0]?.row || 0)
            );
          this.seatData = this.seatMobile;
          this.availableSeatCount = this.seatMobile
            .flat()
            .filter((seat: any) => this.isSeatSpace(seat) && this.isSeatAvailable(seat))
            .length;
          this.dataLoading=false;

        },
        error => {
          this.seatErrors=true;
          this.dataLoading =false;

          return EMPTY;

        }
      );
      }
      seatSelect(event: any, result: any, id: number, space_type: string, fare: any) {
        let seatsPrices = result.seats_types;
        let seatPriceKSH = '';
        let seatPriceUGX = '';
        // Find seat price for the selected seat type (vip, business, normal)
        for (let i = 0; i < seatsPrices.length; i++) {
            if (space_type === seatsPrices[i].alias) {
                seatPriceKSH = seatsPrices[i].fare; // Price in KSH
                seatPriceUGX = fare.currencies['UGX']; // Price in UGX
            }
        }

    
        // Handle seat selection logic
        if (event.srcElement.parentElement.classList.contains('unavailable')) {
            return; // If seat is unavailable, do nothing
        }
    
        if (this.seatsSelected.some(e => e.id === id)) {
 
            // If seat is already selected, deselect it
            if (event.srcElement.classList.contains('single-seat')) {
                event.srcElement.classList.remove('selected');
            }
    
            // Subtract the seat prices from the total
            this.totalFareKSH = this.totalFareKSH - parseInt(seatPriceKSH);
            this.totalFareUGX = this.totalFareUGX - parseInt(seatPriceUGX);
    
            // Remove the seat from the selected seats list
            this.seatsSelected = this.seatsSelected.filter(item => item.id !== id);
            event.srcElement.parentElement.classList.remove('selected');
        } else {
   
            // If seat is not selected, select it
            if (event.srcElement.classList.contains('single-seat')) {
                event.srcElement.classList.add('selected');
            }
    
            // Add the seat prices to the total
            this.totalFareKSH = this.totalFareKSH + parseInt(seatPriceKSH);
            this.totalFareUGX = this.totalFareUGX + parseInt(seatPriceUGX);
    
            // Add the seat to the selected seats list
            this.seatsSelected.push({
                id: id,
                space_type: space_type,
                fareKSH: fare.currencies['UGX'] == 0 ? seatPriceKSH : fare.currencies['Ksh'],  // Save the KSH fare
                fareUGX: fare.currencies['UGX']   // Save the UGX fare
            });

          

            event.srcElement.parentElement.classList.add('selected');
    
            if (this.return_schedule) {
                this.busSelected = result;
                this.currentBusId = result.id;
                this.busOperatorSelected = result.operator.alias;
                this.isBusSelected = true;
            }
        }
    }
    

     refreashSeats(){
      this.dataLoading=false;

      this.service.onSearch(this.bookingdetails).subscribe(
        response => {
          this.dataLoading=false;
          this.res = response;
          this.schedule =  this.results.schedule;
          this.routename =  this.results.route;
          this.pickup =  this.results.pickup;
          this.dropoff =  this.results.dropoff;
          this.fleet =  this.results.fleet;
          this.seat_price =  this.results.seat_price;
        },
        error => {
          // console.log('oops', error);
        }
      );

    }

    submitForm(result) {

      this.submitted = false;
      if (result.dropoff_points.length <1 ) result.dropoff_points.push(this.dropOffInit);
      if (result.boarding_points.length <1 ) result.boarding_points.push(this.pickUpInit);
                    // pickupanddropoff
 
     this.submittedMashPoa = true;

     if(!this.pickupForm.valid){

       return
     }

     let fvalues = this.pickupForm.value;
     // Close the current journey overlay before fetching the return schedule.
     // Keeping it mounted made Continue appear unresponsive for the full API wait.
     this.seatDrawerOpen = false;
     this.boardingDrawerOpen = false;


      if(this.isReturnTicket && !this.isReturnTicketSelected){
        this.isReturnTicketSelected=true;
        let resultsData:any;
        let resultSeats:any;
        let pickupreturn:any;
        resultsData=result;
        pickupreturn = fvalues;

      
        resultSeats=this.seatsSelected;
    
        this.pickupreturnlocation = pickupreturn.pickupLocation
        this.dropoffreturnlocation = pickupreturn.dropoffLocation

          
        this.formdataReturn={
          'result':resultsData,
          'fare': resultsData.fare,
          'title': resultsData.from + ' to ' + resultsData.to,
          'total_fare':this.totalFare,
          "search_details": this.bookingdetails,
          'search_from' : this.fromPlaceholder,
          'search_to' :this.toPlaceholder,
          'pickup' : resultsData.boarding_points.length,
          'pickup_location':this.pickupreturnlocation,
          'dropoff_location':this.dropoffreturnlocation,
          'dropoff' :resultsData.dropoff_points,
          'totalfareKSH' : this.totalFareKSH,
          'totalfareUGX' : this.totalFareUGX,
          'seatsSelected' : resultSeats,
          'booking_session_id':this.booked_seat_session_id
        }
      }else{
        let initialData:any;
        initialData=result;

        this.pickuplocation = fvalues.pickupLocation
        this.dropofflocation = fvalues.dropoffLocation
          
     
          // initialData.departure_date = this.finalTravelDate;
        
        this.formdataTravel={
          'result':initialData,
          'fare': initialData.fare,
          'title': initialData.from + ' to ' + initialData.to,
          'total_fare':this.totalFare,
          "search_details": this.bookingdetails,
          'pickup' : initialData.boarding_points.length,
          'dropoff' :initialData.dropoff_points,
          'pickup_location':this.pickuplocation,
          'dropoff_location':this.dropofflocation,
          'search_from' : this.fromPlaceholder,
          'search_to' :this.toPlaceholder,
          'totalfareKSH' : this.totalFareKSH,
          'totalfareUGX' : this.totalFareUGX,
          'seatsSelected' : this.seatsSelected,
          'booking_session_id':this.booked_seat_session_id
        }


        this.pickupForm.reset();
        this.submittedMashPoa = false;

      }
      //check if the trip is one way
      if(this.bookingdetails.returning && !this.isReturnTicket){
        this.interChangeValues(this.bookingdetails.dropoff,this.bookingdetails.pickup);
        let returnsearch={
          'pickup' : this.bookingdetails.dropoff,
          'dropoff' : this.bookingdetails.pickup,
          'pickupname' : this.bookingdetails.dropoff,
          'dropoffname' :this.bookingdetails.pickup,
          'traveldate' :this.bookingdetails.returndate,
          'returndate' :'',
        }
        this.isReturnTicket=true;
        this.interChangeValues(this.bookingdetails.dropoff,this.bookingdetails.pickup);
        this.searchBuses(returnsearch);
      } else if(this.bookingdetails.returning && this.isReturnTicket){
        let paytravel=Base64.encode(JSON.stringify(this.formdataTravel));
     
        let payreturn=Base64.encode(JSON.stringify(this.formdataReturn));
        let bookingdetails=Base64.encode(JSON.stringify( this.bookingdetails));
        let syncData={
            'travel':paytravel,
            'return':payreturn,
            'bookingdetails':bookingdetails,
            'returning':true
        }
        let pay=Base64.encode(JSON.stringify(syncData));
        let paymessage=Base64.encode("Opps sory mate!");
        this.dataService.changeMessage(pay);
        localStorage.setItem('search-mashpoa', bookingdetails);
        localStorage.setItem('payments-mashpoa',pay)
        this.router.navigate(['/payments', paymessage])
      } else {
        let paytravel=Base64.encode(JSON.stringify(this.formdataTravel));
        let bookingdetails=Base64.encode(JSON.stringify(this.bookingdetails));
        this.bookingdetails
          let syncData={
            'travel':paytravel,
            'return':'',
            'bookingdetails':bookingdetails,
            'returning':false
          }
        let pay=Base64.encode(JSON.stringify(syncData));
        let paymessage=Base64.encode("Opps sory mate!");
        this.dataService.changeMessage(pay);
        localStorage.setItem('search-mashpoa', bookingdetails);
        localStorage.setItem('payments-mashpoa',pay)
        this.router.navigate(['/payments', paymessage])
      }

      
    }

  searchBuses(search){
    this.isResultsLoading=true;
    this.destinationLoading=true;
    this.travelDateInit=search.traveldate;
    this.pickUpInit = search.pickupname;
    this.dropOffInit = search.dropoffname;
    this.pickup =   search.pickup;
    this.dropoff =  search.dropoff;
    this.interChangeValues(search.pickupname,search.dropoffname);
    this.finalTravelDate =search.traveldate;
    this.finalReturnDateInit =search.returndate
    this.service.onSearch(search).subscribe(
      response => {
        this.isResultsLoading=false;
        this.destinationLoading=false;
        this.res = response;

        if(search.returning){
          let newResults=[];
          let resultsData = this.res.data.initial_trip;
          for(let i=0;i < resultsData.length;i++)
          {
              if (!resultsData[i]?.operator?.alias?.endsWith('-none')) {
                newResults.push(resultsData[i]);
              }
          }
          this.results=newResults;
          this.return_schedule = this.res.data.return_trip;
        }else{
          let newResults=[];
          let resultsData = this.res.data.schedule;
          for(let i=0;i < resultsData.length;i++)
          {
              if (!resultsData[i]?.operator?.alias?.endsWith('-none')) {
                newResults.push(resultsData[i]);
              }
          }
          this.results=newResults;
        }
        if( this.res.data ) {
          this.pickup =  this.pickUpInit;
          this.dropoff =  this.dropOffInit;
        }

        this.resultsholder = this.results;
        this.reopenSeatDrawerAfterConflict();

      },
      error => {
        return EMPTY;
      }
    );

  }

  private reopenSeatDrawerFromCheckout(): void {
    const rawRecovery = sessionStorage.getItem(SEAT_CONFLICT_RECOVERY_STORAGE_KEY);
    if (!rawRecovery) {
      return;
    }

    try {
      const recovery = JSON.parse(rawRecovery) as SeatConflictRecovery;
      const selectedBus = recovery.selectedBus || this.checkoutSelectedBus();
      if (!selectedBus) {
        return;
      }

      sessionStorage.removeItem(SEAT_CONFLICT_RECOVERY_STORAGE_KEY);
      this.seatRecoveryMessage = 'Your previous seat is no longer available. Please choose another seat.';
      this.selectSeats(selectedBus);
    } catch {
      // Fall back to reopening after refreshed search results have loaded.
    }
  }

  private checkoutSelectedBus(): Record<string, unknown> | null {
    const rawCheckout = localStorage.getItem('payments-mashpoa');
    if (!rawCheckout) {
      return null;
    }
    const checkout = JSON.parse(Base64.decode(rawCheckout));
    const travel = JSON.parse(Base64.decode(checkout.travel));
    return travel?.result || null;
  }

  private reopenSeatDrawerAfterConflict(): void {
    const raw = sessionStorage.getItem(SEAT_CONFLICT_RECOVERY_STORAGE_KEY);
    if (!raw) {
      return;
    }

    sessionStorage.removeItem(SEAT_CONFLICT_RECOVERY_STORAGE_KEY);
    try {
      const recovery = JSON.parse(raw) as SeatConflictRecovery;
      const matchingBus = (this.results || []).find((result: any) =>
        this.matchesRecoveredBus(result, recovery)
      );
      if (!matchingBus) {
        return;
      }
      this.seatRecoveryMessage = 'Your previous seat is no longer available. Please choose another seat.';
      this.selectSeats(matchingBus);
    } catch {
      // Invalid recovery state should leave the user safely on the search results.
    }
  }

  private matchesRecoveredBus(result: any, recovery: SeatConflictRecovery): boolean {
    const identifiers: Array<[unknown, string]> = [
      [result?.trip_id, recovery.tripId],
      [result?.route_schedule_id, recovery.routeScheduleId],
      [result?.id ?? result?.bus_id ?? result?.fleet_registration_id, recovery.busId]
    ];
    const primaryIdentifier = identifiers.find(([actual, expected]) =>
      actual !== undefined && actual !== null && actual !== '' && !!expected
    );
    if (!primaryIdentifier) {
      return false;
    }
    const identifiersMatch = String(primaryIdentifier[0]) === primaryIdentifier[1];
    const aliasMatches = !recovery.operatorAlias ||
      String(result?.operator?.alias || '') === recovery.operatorAlias;
    return identifiersMatch && aliasMatches;
  }


  selectEvent(item) {
    // do something with selected item
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e){
    // do something when input is focused
  }


}
